import cx from 'classnames';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Icon from '../Icon';
import Button from '../Button';

const Card = ({ card, data, isDownloadList }) => {
  const { isEditMode, cardsPerRow, align, globalStyle, globalLabel } = data;
  const {
    style = globalStyle,
    icon,
    title,
    description,
    href,
    label,
    openLinkInNewTab,
    size,
  } = card;

  const cardStyle = cx(`card-${cardsPerRow}`, align);

  return (
    <div className={cardStyle}>
      <MaybeWrap
        condition={href?.length}
        as={UniversalLink}
        openLinkInNewTab={openLinkInNewTab}
        className={'inner'}
        href={href?.length && !isEditMode ? href[0]['@id'] : null}
      >
        <MaybeWrap condition={!href?.length} as="div" className={'inner'}>
          {icon ? (
            <div className={'icon-wrapper'}>
              <Icon name={icon} className={cx('icon', style)} />
            </div>
          ) : null}
          {title ? <div className={'title'}>{title}</div> : null}
          {description ? <div className={'desc'}>{description}</div> : null}
          {href?.length && (label || globalLabel) ? (
            <div className={'more-link'}>
              <Button>
                {isDownloadList && <Icon name="download" />}
                {label || globalLabel}
              </Button>

              {isDownloadList && size && <span className="size">{size}</span>}
            </div>
          ) : null}
        </MaybeWrap>
      </MaybeWrap>
    </div>
  );
};

export default Card;
